import { render, staticRenderFns } from "./Workshop-Club-Form.vue?vue&type=template&id=c63d72be&scoped=true"
import script from "./Workshop-Club-Form.vue?vue&type=script&lang=js"
export * from "./Workshop-Club-Form.vue?vue&type=script&lang=js"
import style0 from "./Workshop-Club-Form.vue?vue&type=style&index=0&id=c63d72be&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c63d72be",
  null
  
)

export default component.exports